import React, { ReactNode } from 'react';
import classNames from 'classnames';
import iphoneImage from 'assets/iphone_x@2x.png';
import './PreviewIphone.pcss';

type Props = {
  className?: string;
  children: string | ReactNode | Element[];
};

export const PreviewIphone = ({ className, children }: Props) => {
  return (
    <div className={classNames(className, 'preview-iphone')}>
      <img className="preview-iphone__image" src={iphoneImage} alt="Iphone" />
      <div className="preview-iphone__content">{children}</div>
    </div>
  );
};
